// Angular
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import SessionStorage from '@app/helpers/SessionStorage';
import { TranslateService } from '@ngx-translate/core';
// 3rdparty

// Hostware

@Component({
  selector: 'app-excluded-services-information-dialog',
  templateUrl: './excluded-services-information-dialog.component.html',
  styleUrls: ['./excluded-services-information-dialog.component.scss']
})
export class ExcludedServicesInformationDialogComponent {
  warningMessage : string = ""
  excludedHtml: string = "";
  /**
   *
   */
  constructor(
    private dialogRef: MatDialogRef<ExcludedServicesInformationDialogComponent>,
    private  translate: TranslateService
    

  ) {
    let excludedArray = SessionStorage.ExcludedServiceNames;
    let exStr: string = "";
    exStr = "<br>"
    excludedArray.forEach(item=> {
      exStr = exStr +  "<strong>" + item.Description + "</strong> <br>" 
    })
    this.warningMessage = translate.instant('payment.szepcard_warning')
    this.excludedHtml =  this.warningMessage.replace("#ex#",exStr) 
  }
  cancel() {
    this.dialogRef.close(undefined)
  }

  submit() {
    this.dialogRef.close('ok')
  }
}
